import { render, staticRenderFns } from "./BosFairListing.vue?vue&type=template&id=4f19853f&scoped=true"
import script from "./BosFairListing.vue?vue&type=script&lang=js"
export * from "./BosFairListing.vue?vue&type=script&lang=js"
import style0 from "./BosFairListing.vue?vue&type=style&index=0&id=4f19853f&prod&lang=scss&scoped=true"
import style1 from "./BosFairListing.vue?vue&type=style&index=1&id=4f19853f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f19853f",
  null
  
)

export default component.exports